<template>
  <Layout>
    <div class="row" v-if="userData.permissions['add_sickbay_visit'] == 1">
      <div class="row">
        <div class="col-12">
          <div class="d-flex justify-content-between">
            <h4>Sickbay Visits</h4>
            {{ new Date().toLocaleDateString("en-US", options) }}
          </div>
        </div>
        <div class="card shadow-lg mt-2">
          <div class="card-body">
            <form @submit.prevent="addVisit" id="new-visit">
              <input v-model="id" type="hidden" />
              <div class="row">
                <div class="col-md-6">
                  <!-- <label>Student</label>
                    <v-select :options="students" placeholder="Select student" v-model="student" :reduce="students => students.student.student_id">
                      <template slot="option" slot-scope="option">
                        <div>{{ option.student.first_name }} {{ option.student.last_name }} {{ option.class.name }} {{ option.stream.name }}</div> 
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div>{{ option.student.first_name }} {{ option.student.last_name }} {{ option.class.name }} {{ option.stream.name }}</div> 
                      </template>
                    </v-select>-->
                  <label
                    >Student :
                    <small class="text-primary">{{
                      student.student_id
                    }}</small></label
                  >

                  <multiselect
                    v-model="student"
                    :options="students"
                    placeholder="Select Student"
                    :custom-label="customLabel"
                  >
                  </multiselect>
                </div>
                <div class="col-md-6">
                  <label>School term</label>
                  <multiselect
                    v-model="schoolterm"
                    label="name"
                    :options="schoolterms"
                  ></multiselect>
                </div>
                <div class="col-md-6">
                  <label>Year</label>
                  <v-select
                    :options="years"
                    placeholder="Select Year"
                    v-model="year"
                  ></v-select>
                </div>
                <div class="col-md-6">
                  <label>Visit date</label
                  ><b-form-input type="date" v-model="visitdate"></b-form-input>
                </div>
                <div class="col-md-6">
                  <label>Sickness</label>
                  <tinymce id="dt1" v-model="sickness" />
                </div>
                <div class="col-md-6">
                  <label>Action taken</label>
                  <tinymce id="dt2" v-model="treatment" />
                </div>
                <div class="form-group d-flex justify-content-end">
                  <b-button
                    type="submit"
                    class="btn mt-2 w-30"
                    variant="primary"
                    ><i class="fas fa-check-circle"></i> Submit</b-button
                  >
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view this Page.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";
import {
  studentMethods,
  studentComputed,
  schooltermMethods,
  schooltermComputed,
} from "@/state/helpers";

export default {
  page: {
    title: "New sickbay Visit ",
    meta: [{ name: "description", content: appConfig.description }],
  },

  components: { Layout, Multiselect },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "New sickbay visit",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Sickbay visit", active: true },
      ],
      options: {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      },
      currentdate: new Date().toLocaleDateString("fr-CA"),
      id: "",
      schoolterm: "",
      year: new Date().getFullYear(),
      sickness: "",
      treatment: "",
      student: "",
      visitdate: new Date().toLocaleDateString("fr-CA"),
    };
  },
  mounted() {
    this.fetchStudents();
    this.fetchSchoolTerms();
    this.schoolterm = this.schoolterms.find((option) => option.active == 1);
  },
  computed: {
    ...studentComputed,
    ...schooltermComputed,
    List() {
      return this.visits.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.visits.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.visits.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {
        yearArray.push(year);
      }
      return yearArray;
    },
  },
  methods: {
    ...studentMethods,
    ...schooltermMethods,
    customLabel(student) {
      return `${student.student.first_name} ${student.student.last_name} ${student.class.name} ${student.stream.name} `;
    },
    async addVisit() {
      let formData = new FormData();
      // formData.append("student", this.student);
      formData.append("student", this.student.student.student_id);

      formData.append("schoolterm", this.schoolterm.id);
      formData.append("visitdate", this.visitdate);
      formData.append("year", this.year);
      formData.append("sickness", this.sickness);
      formData.append("treatment", this.treatment);
      let url = "/addvisit";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.$swal({
            title: "Successfuly added",
            text: response.data.message,
            icon: "success",
          });
          this.$router.push({ name: "viewvisits" });
        }
      });
    },
  },
};
</script>
